module.exports = __webpack_public_path__ + "static/media/tick-circle-disable.abcb83b1.svg";